import * as Yup from "yup";

const editProfileValidation = Yup.object({
  first_name: Yup.string().required("first name is required"),
  last_name: Yup.string().required("last name is required"),
  about_me: Yup.string().required("description is required"),
  work_place: Yup.string().optional().nullable(),

  customer_type_ids: Yup.array()
    .min(1, "Please select at least one customer type")
    .max(3, "You can select a maximum of 3 customer types"),

  categories_ids: Yup.array()
    .min(1, "Please select at least one category")
    .max(3, "You can select a maximum of 3 category"),

  job_type: Yup.string().when("influencer_type_id", {
    is: (influencer_type_id: number) => influencer_type_id === 10,
    then: (schema) => schema.required("Job Type is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  //   images: Yup.array().min(1, "Image is required"),
  //   industry_ids: Yup.array().min(1, "Industry is required"),
  //   category_ids: Yup.array().min(1, "Category is required"),
  //   description: Yup.string().required("Description is required"),
  //   whats_included: Yup.string().required("whats included is required"),
  //   additional_info: Yup.string().optional().nullable(),
  //   capacity: Yup.number().optional().nullable(),
  //   cancellation_policy: Yup.string().required("Cancellation policy is required"),
  //   customer_input_field: Yup.string().optional().nullable(),
  //   max_guest: Yup.number()
  //     .typeError("Max number of guests must be a number")
  //     .nullable(),
  //   min_age: Yup.number().optional().nullable(),
  //   max_age: Yup.number().optional().nullable(),
});

export default editProfileValidation;
